export default {
	en: (choice) => {
		return choice != 1 ? 1 : 0
	},

	es: (choice) => {
		return choice != 1 ? 1 : 0
	},

	pt: (choice) => {
		return choice != 1 ? 1 : 0
	},

	de: (choice) => {
		return choice != 1 ? 1 : 0
	},

	it: (choice) => {
		return choice != 1 ? 1 : 0
	},

	fr: (choice) => {
		return choice > 1 ? 1 : 0
	},

	/**
	 * 1-miesiąc
	 * 2, 3, 4 - miesiące
	 * 5–21 - miesięcy
	 */
	pl: (choice, choicesLength) => {
		if (choice === 0) {
			return choicesLength - 1
		}

		if (choice === 1) {
			return 0
		}

		if (choice >= 2 && choice <= 4) {
			return 1
		}

		return choicesLength - 1
	},
}
